<template>
  <div>
    <div :class="{ 'full-table': items.length }" class="custom-table__wrapper">
      <div v-if="selectable && !singleSelectable" class="d-flex align-items-center justify-content-end mb-4">
        <span class="font-weight-light">{{ $t("vybrano") }}: {{ selectedRows.length }}</span>
        <span v-if="selectedRows.length != sortedItems.length" class="link ml-4" @click="selectAll('selectAll')">
          {{ $t("vybratVse") }}
        </span>
        <span v-if="selectedRows.length > 0" class="link ml-2" @click="selectAll('deselect')">
          {{ $t("OdvybratVse") }}
        </span>
      </div>
      <div v-if="items.length > 0" :class="{ 'full-width': fullWidth, 'with-kebab': kebab }" class="custom-table fixed">
        <div class="custom-table__header d-flex align-items-center">
          <div v-if="kebab" class="custom-table__column kebab px-2" />
          <div
            v-for="(column, index) in columns"
            :key="index"
            :class="[
              !column.class ? column.name : '',
              { sortable: column.sortable, name: index == 0 && !column.class },
              column.class
            ]"
            class="custom-table__column px-2"
          >
            <div
              v-if="selectable && !singleSelectable && index == 0"
              :class="{ checked: allOnPageSelected() }"
              class="custom-control custom-control--checkbox"
              @click="selectAllOnPage()"
            >
              <input class="custom-control-input" type="checkbox" />
            </div>
            <div class="title" @click="sortItemsBy(column.name)">
              {{ $t(column.name) }}
            </div>
            <div v-if="sortBy == column.name" class="sorting">
              <span v-if="sortType == 'desc'">▼</span>
              <span v-if="sortType == 'asc'">▲</span>
            </div>
          </div>
        </div>
        <div class="custom-table__content">
          <div
            v-for="(item, index) in sortedItems"
            :key="index"
            :class="['custom-table__row d-flex', item.customRowClass ? item.customRowClass : '']"
          >
            <div
              v-for="(column, id) in columns"
              :key="id"
              :class="[
                !column.class ? column.name : '',
                { sortable: column.sortable, name: id == 0 && !column.class },
                column.class
              ]"
              class="custom-table__column px-2"
            >
              <div
                v-if="selectable && !item.notSelectable && id == 0"
                :class="{
                  checked: selectedRows.filter((e) => e[itemId] === item[itemId]).length > 0
                }"
                class="custom-control custom-control--checkbox"
                @click="addToSelected(item)"
              >
                <input class="custom-control-input" type="checkbox" />
              </div>
              <div
                v-if="selectable && item.notSelectable && id == 0"
                class="custom-control custom-control--checkbox disabled"
              >
                <input class="custom-control-input" disabled type="checkbox" />
              </div>

              <span>
                <span v-if="column.action" @click="$emit(column.action, item)">
                  <span class="link-gray font-weight-bolder">
                    <span>{{ getNested(item, column.name) }}</span>
                  </span>
                </span>
                <span v-else>
                  <span v-if="column.nested">
                    <span v-for="(nested, index) in getNested(item, column.name)" :key="index">
                      <div v-if="index + 1 < getNested(item, column.name).length">{{ nested }},</div>
                      <div v-else>{{ nested }}</div>
                    </span>
                  </span>
                  <span v-else>
                    {{ getNested(item, column.name) }}
                  </span>
                </span>
              </span>
            </div>
            <div
              v-if="kebab && itemId"
              id="kebab"
              ref="kebab"
              :class="{
                opened: openedItem[itemId] == item[itemId] && showKebab
              }"
              class="custom-table__column kebab px-2 d-flex justify-content-end"
            >
              <div class="dropdown-actions">
                <div class="atom-icon mr-0" @click="openKebab(item)">
                  <img src="@/assets/icons/menu/ico-kebab.svg" />
                </div>
                <div
                  v-if="openedItem[itemId] == item[itemId] && showKebab"
                  v-click-outside="closeKebab"
                  class="dropdown-actions__wrapper"
                >
                  <div class="dropdown-actions__inner" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="items.length > 0"
        :class="{ 'full-width': fullWidth, 'with-kebab': kebab }"
        class="custom-table fixed fixed-last"
      >
        <div class="custom-table__header d-flex align-items-center">
          <div v-if="kebab" class="custom-table__column kebab px-2" />
          <div
            v-for="(column, index) in columns"
            :key="index"
            :class="[
              !column.class ? column.name : '',
              { sortable: column.sortable, name: index == 0 && !column.class },
              column.class
            ]"
            class="custom-table__column px-2"
          >
            <div
              v-if="selectable && !singleSelectable && index == 0"
              :class="{ checked: allOnPageSelected() }"
              class="custom-control custom-control--checkbox"
              @click="selectAllOnPage()"
            >
              <input class="custom-control-input" type="checkbox" />
            </div>
            <div class="title" @click="sortItemsBy(column.name)">
              {{ $t(column.name) }}
            </div>
            <div v-if="sortBy == column.name" class="sorting">
              <span v-if="sortType == 'desc'">▼</span>
              <span v-if="sortType == 'asc'">▲</span>
            </div>
          </div>
        </div>
        <div class="custom-table__content">
          <div
            v-for="(item, index) in sortedItems"
            :key="index"
            :class="['custom-table__row d-flex', item.customRowClass ? item.customRowClass : '']"
          >
            <div
              v-if="kebab && itemId"
              id="kebab"
              ref="kebab"
              :class="{
                opened: openedItem[itemId] == item[itemId] && showKebab
              }"
              class="custom-table__column kebab px-2 d-flex justify-content-end"
            >
              <div class="dropdown-actions">
                <div class="atom-icon mr-0" @click="openKebab(item)">
                  <img src="@/assets/icons/menu/ico-kebab.svg" />
                </div>
                <div
                  v-if="openedItem[itemId] == item[itemId] && showKebab"
                  v-click-outside="closeKebab"
                  class="dropdown-actions__wrapper"
                >
                  <div class="dropdown-actions__inner">
                    <slot :run-action="runAction" name="actions" />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="(column, id) in columns"
              :key="id"
              :class="[
                !column.class ? column.name : '',
                { sortable: column.sortable, name: id == 0 && !column.class },
                column.class
              ]"
              class="custom-table__column px-2"
            >
              <div
                v-if="selectable && !item.notSelectable && id == 0"
                :class="{
                  checked: selectedRows.filter((e) => e[itemId] === item[itemId]).length > 0
                }"
                class="custom-control custom-control--checkbox"
                @click="addToSelected(item)"
              >
                <input class="custom-control-input" type="checkbox" />
              </div>
              <div
                v-if="selectable && item.notSelectable && id == 0"
                class="custom-control custom-control--checkbox disabled"
              >
                <input class="custom-control-input" disabled type="checkbox" />
              </div>

              <span>
                <span v-if="column.action" @click="$emit(column.action, item)">
                  <span class="link-gray font-weight-bolder">
                    <span>{{ getNested(item, column.name) }}</span>
                  </span>
                </span>
                <span v-else>
                  <span v-if="column.nested">
                    <span v-for="(nested, index) in getNested(item, column.name)" :key="index">
                      <div v-if="index + 1 < getNested(item, column.name).length">{{ nested }},</div>
                      <div v-else>{{ nested }}</div>
                    </span>
                  </span>
                  <span v-else>{{ getNested(item, column.name) }}</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="items.length > 0"
        :class="{ 'full-width': fullWidth, 'with-kebab': kebab }"
        class="custom-table relative"
      >
        <div :class="{ 'full-width': fullWidth, 'with-kebab': kebab }" class="custom-table__inner">
          <div class="custom-table__header d-flex align-items-center">
            <div
              v-for="(column, index) in columns"
              :key="index"
              :class="[
                !column.class ? column.name : '',
                {
                  sortable: column.sortable,
                  name: index == 0 && !column.class
                },
                column.class
              ]"
              class="custom-table__column px-2"
            >
              <div
                v-if="selectable && !singleSelectable && index == 0"
                :class="{ checked: isSelectedAllOnPage }"
                class="custom-control custom-control--checkbox"
                @click="selectAll()"
              >
                <input class="custom-control-input" type="checkbox" />
              </div>
              <div class="title" @click="sortItemsBy(column.name)">
                {{ $t(column.name) }}
              </div>
              <div v-if="sortBy == column.name" class="sorting">
                <span v-if="sortType == 'desc'">▼</span>
                <span v-if="sortType == 'asc'">▲</span>
              </div>
            </div>
            <div v-if="kebab" class="custom-table__column kebab px-2" />
          </div>
          <div class="custom-table__content">
            <div
              v-for="(item, index) in sortedItems"
              :key="index"
              :class="['custom-table__row d-flex', item.customRowClass ? item.customRowClass : '']"
            >
              <div
                v-for="(column, id) in columns"
                :key="id"
                :class="[
                  !column.class ? column.name : '',
                  { sortable: column.sortable, name: id == 0 && !column.class },
                  column.class
                ]"
                class="custom-table__column px-2"
              >
                <div
                  v-if="selectable && id == 0"
                  :class="{
                    checked: selectedRows.filter((e) => e[itemId] === item[itemId]).length > 0
                  }"
                  class="custom-control custom-control--checkbox"
                  @click="addToSelected(item)"
                >
                  <input class="custom-control-input" type="checkbox" />
                </div>
                <span v-if="column.action" @click="$emit(column.action, item)">
                  <span class="link-gray font-weight-bolder">
                    <span>{{ $t(getNested(item, column.name) ?? "") }}</span>
                  </span>
                </span>
                <span v-else>
                  <span v-if="column.nested">
                    <span v-for="(nested, index) in getNested(item, column.name)" :key="index">
                      <div v-if="index + 1 < getNested(item, column.name).length">{{ $t(nested ?? "") }},</div>
                      <div v-else>{{ $t(nested ?? "") }}</div>
                    </span>
                  </span>
                  <span
                    v-else-if="column.filter == 'dateTimeMicro'"
                    v-html="$filters.dateTimeMicro(getNested(item, column.name), column.separator)"
                  />
                  <span
                    v-else-if="column.filter == 'dateTime'"
                    v-html="$filters.dateTime(getNested(item, column.name), column.separator)"
                  />
                  <span
                    v-else-if="column.filter == 'replaceVariables'"
                    v-html="$filters.replaceVariables($t(getNested(item, column.name) ?? ''), item)"
                  />
                  <span v-else>{{ $t(String(getNested(item, column.name) ?? "")) }}</span>
                </span>
              </div>
              <div
                v-if="kebab && itemId"
                id="kebab"
                ref="kebab"
                :class="{
                  opened: openedItem[itemId] == item[itemId] && showKebab
                }"
                class="custom-table__column kebab px-2 d-flex justify-content-end"
              >
                <div class="dropdown-actions">
                  <div class="atom-icon mr-0" @click="openKebab(item)">
                    <img src="@/assets/icons/menu/ico-kebab.svg" />
                  </div>
                  <div
                    v-if="openedItem[itemId] == item[itemId] && showKebab"
                    v-click-outside="closeKebab"
                    class="dropdown-actions__wrapper"
                  >
                    <div class="dropdown-actions__inner">
                      <slot :run-action="runAction" name="actions" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="my-5">{{ $t("nicKZobrazeni") }}.</div>
    </div>
    <div v-if="sortedItems.length > 0" class="custom-table__footer d-flex align-items-center justify-content-between">
      <Paging
        :page="{
          currentPage: page,
          rowsPerPage: rowsPerPage,
          itemsTotalCount: total
        }"
        @prev-page="page--"
        @next-page="page++"
        @rows-per-page="rowsPerPage = $event"
        @reload-items="loadData"
      />
    </div>
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import Paging from "@/components/paging/paging.vue"

export default {
  components: {
    Paging,
    ErrorModal
  },
  props: {
    endpoint: String,
    columns: Array,
    fullWidth: Boolean,
    kebab: Boolean,
    itemId: String,
    selectable: Boolean,
    singleSelectable: Boolean,
    defaultSortingIndex: {
      default: 0
    },
    defaultSortType: {
      default: "desc"
    }
  },
  data() {
    return {
      items: [],
      sortType: "desc",
      sortBy: "timestamp",
      sortedItems: [],
      rowsPerPage: 20,
      page: 0,
      openedItem: {},
      errorsToTranslate: [],
      openedRowsSelect: false,
      selectedRows: [],
      isSelectedAllOnPage: false,
      showKebab: false,
      total: 0
    }
  },
  computed: {},
  watch: {
    rowsPerPage() {
      this.page = 0
      /** load data on rowsPerPage change */
      if (localStorage.rowsPerPage != this.rowsPerPage) this.loadData()
      localStorage.rowsPerPage = this.rowsPerPage
    },
    page() {
      /** load data on paging */
      this.loadData()
      this.allOnPageSelected()
    },
    items() {
      this.sortedItems = this.items
    },
    /** watch endpoint change */
    endpoint() {
      this.loadData()
    },
    openedItem() {
      this.openedItem[this.itemId] != undefined ? this.$emit("opened", this.openedItem) : this.$emit("opened", null)
    },
    selectedRows() {
      this.selectedRows.length > 0 ? this.$emit("selectedRows", this.selectedRows) : this.$emit("selectedRows", null)
    }
  },
  mounted() {
    /** load data if endpoint is set */
    if (this.endpoint) {
      this.loadData()
    }
    this.sortType = this.defaultSortType
    this.selectedRows = []
    if (localStorage.rowsPerPage) {
      var rows1 = localStorage.rowsPerPage
      this.rowsPerPage = rows1
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }
    this.sortBy = this.columns[this.defaultSortingIndex].name
  },
  methods: {
    loadData() {
      this.errorsToTranslate = []
      this.$store.commit("modals/setWaitingLoader", this.$t("Načítám data"))

      var sort = "%2D"
      if (this.sortType == "asc") {
        sort = "%2B"
      }

      axios
        .get(
          this.endpoint +
            "?sort=" +
            sort +
            this.sortBy +
            "&limit=" +
            this.rowsPerPage +
            "&offset=" +
            this.page * this.rowsPerPage
        )
        .then((result) => {
          this.items = result.data.data
          this.total = result.data.metadata.count

          this.$store.commit("modals/setWaitingLoader", "")
        })
        .catch((error) => {
          if (error.status) {
            let err = []
            err.errors = []
            err.errors.push({
              message: error.status + " " + error.statusText
            })
            this.errorsToTranslate.push(err)
            if (this.errorsToTranslate.length > 0) {
              this.openedError = true
            }
          }
          this.$store.commit("modals/setWaitingLoader", "")
        })
    },
    sortItemsBy(sortBy, skipSortType) {
      this.sortBy = sortBy

      // let sort = new String(sortBy);
      // we need to skip sortType change after language change for example
      if (!skipSortType) {
        if (this.sortType == "asc") {
          this.sortType = "desc"
        } else {
          this.sortType = "asc"
        }
      }

      this.loadData()
    },
    getNested(item, name) {
      let splited = name.split(".")
      if (splited.length == 1) {
        return item[name]
      } else if (splited.length == 2) {
        return item[splited[0]][splited[1]]
      } else if (splited.length == 3) {
        return item[splited[0]][splited[1]][splited[2]]
      } else if (splited.length == 4) {
        return item[splited[0]][splited[1]][splited[2]][splited[3]]
      }
    },
    openKebab(item) {
      this.showKebab = true
      this.openedItem = this.openedItem == item ? {} : item
    },
    runAction() {
      this.$emit
    },
    addToSelected(item) {
      if (this.selectedRows.filter((e) => e[this.itemId] === item[this.itemId]).length > 0) {
        const index = this.selectedRows.map((e) => e[this.itemId]).indexOf(item[this.itemId])
        this.selectedRows.splice(index, 1)
      } else {
        if (this.singleSelectable) {
          this.selectedRows = []
        }
        this.selectedRows.push(item)
      }
    },
    allOnPageSelected() {
      let itemsOnPage = this.sortedItems
        .slice(this.page * this.rowsPerPage, Number(this.page * this.rowsPerPage) + Number(this.rowsPerPage))
        .filter((a) => a.notSelectable != true)

      let itemsOnPageId = itemsOnPage.map((d) => d[this.itemId])
      let allItemsId = Array.from(this.selectedRows).map((d) => d[this.itemId])
      console.log("allItemsId")
      console.log(allItemsId)
      console.log("itemsOnPageId")
      console.log(itemsOnPageId)
      if (itemsOnPageId.every((ai) => allItemsId.includes(ai))) {
        return true
      } else {
        return false
      }
    },
    selectAllOnPage() {
      let itemsOnPage = this.sortedItems
        .slice(this.page * this.rowsPerPage, Number(this.page * this.rowsPerPage) + Number(this.rowsPerPage))
        .filter((a) => a.notSelectable != true)

      let itemsOnPageId = itemsOnPage.map((d) => d[this.itemId])
      let allItemsId = Array.from(this.selectedRows).map((d) => d[this.itemId])
      if (itemsOnPageId.every((ai) => allItemsId.includes(ai))) {
        let indexes = []
        itemsOnPage.forEach((element) => {
          indexes.push(Array.from(this.selectedRows).indexOf(element))
        })
        this.selectedRows.splice(indexes[0], indexes.length)
      } else {
        let indexes = []
        let same = []
        this.selectedRows.forEach((selected) => {
          let filteredArray = itemsOnPage.filter((e) => e[this.itemId] === selected[this.itemId])
          same.push(filteredArray[0])
        })
        same.forEach((element) => {
          if (element != undefined) {
            indexes.push(this.selectedRows.findIndex((obj) => obj[this.itemId] == element[this.itemId]))
          }
        })
        for (var i = indexes.length - 1; i >= 0; i--) {
          this.selectedRows.splice(indexes[i], 1)
        }
        this.selectedRows =
          this.selectedRows.length > 0
            ? this.selectedRows.concat.apply(this.selectedRows, itemsOnPage)
            : [].concat.apply([], itemsOnPage)

        let filternotSelectable = []
        this.selectedRows.forEach((selected) => {
          console.log(selected.notSelectable)
          if (selected.notSelectable != true) {
            console.log(selected)
            filternotSelectable.push(selected)
          }
        })
        this.selectedRows = filternotSelectable
        console.log("this.selectedRows")
        console.log(this.selectedRows)
      }
    },
    selectAll(type) {
      if (type === "deselect") {
        this.selectedRows = []
      } else if (type === "selectAll") {
        this.sortedItems.forEach((selected) => {
          if (selected.notSelectable != true) {
            this.selectedRows = this.selectedRows.concat([selected])
          }
        })
      }
    },
    openModal1(item) {
      this.$emit("openModal1", item)
    },
    closeKebab() {
      this.showKebab = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
